module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAUCAYAAADoZO9yAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADvSURBVEhLvdXPDYIwGIfholHjzRG8mHBkBEkcBCfTOYyGFTx6dASv1hDsV/vzf6H9Cn0T0haS9gkcEKHNy3pGl1myS8zIigCT6lbS/Doc5ec8uegHjNgQINQGGa1rIY4hGBbkG4FCMN4QGwJxMV4QC2JrxsKMLIwzxIY4rcZrmqR7uVEDG+MEaUOgEEwrxBWBuJhGiC8CcTBWCBeBfDF/IaEI5IP5gXSFQK6YD0jXCOSCeUL6QqA2jIb0jUBNmCQWAtkwg2kll7EQlNkb/yf6JBkZ9CI9yEJJa6ONEp2lz1Rnm1uPFjv5/lai9DpTiDuOyfRJo2fNRgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/up-carot-large.png
// module id = 1813
// module chunks = 0